import { render, staticRenderFns } from "./MemoryGame.vue?vue&type=template&id=249a074e&scoped=true"
import script from "./MemoryGame.vue?vue&type=script&lang=js"
export * from "./MemoryGame.vue?vue&type=script&lang=js"
import style0 from "./MemoryGame.vue?vue&type=style&index=0&id=249a074e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249a074e",
  null
  
)

export default component.exports